import React from 'react';
import View from './View';
import adaptData from './adaptData';

const ResultsList = ({ data }) => {
   return <View {...adaptData(data)} />;
};

export default ResultsList;
